﻿/*
 * Globalize Culture he-IL
 *
 * http://github.com/jquery/globalize
 *
 * Copyright Software Freedom Conservancy, Inc.
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://jquery.org/license
 *
 * This file was generated by the Globalize Culture Generator
 * Translation: bugs found in this file need to be fixed in the generator
 */

(function(window, undefined) {
  var Globalize;

  if (
    typeof require !== "undefined" &&
    typeof exports !== "undefined" &&
    typeof module !== "undefined"
  ) {
    // Assume CommonJS
    Globalize = require("globalize");
  } else {
    // Global variable
    Globalize = window.Globalize;
  }

  Globalize.addCultureInfo("he-IL", "default", {
    name: "he-IL",
    englishName: "Hebrew (Israel)",
    nativeName: "עברית (ישראל)",
    language: "he",
    isRTL: true,
    numberFormat: {
      NaN: "לא מספר",
      negativeInfinity: "אינסוף שלילי",
      positiveInfinity: "אינסוף חיובי",
      percent: {
        pattern: ["-n%", "n%"]
      },
      currency: {
        pattern: ["$-n", "$ n"],
        symbol: "₪"
      }
    },
    calendars: {
      standard: {
        days: {
          names: [
            "יום ראשון",
            "יום שני",
            "יום שלישי",
            "יום רביעי",
            "יום חמישי",
            "יום שישי",
            "שבת"
          ],
          namesAbbr: [
            "יום א",
            "יום ב",
            "יום ג",
            "יום ד",
            "יום ה",
            "יום ו",
            "שבת"
          ],
          namesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"]
        },
        months: {
          names: [
            "ינואר",
            "פברואר",
            "מרץ",
            "אפריל",
            "מאי",
            "יוני",
            "יולי",
            "אוגוסט",
            "ספטמבר",
            "אוקטובר",
            "נובמבר",
            "דצמבר",
            ""
          ],
          namesAbbr: [
            "ינו",
            "פבר",
            "מרץ",
            "אפר",
            "מאי",
            "יונ",
            "יול",
            "אוג",
            "ספט",
            "אוק",
            "נוב",
            "דצמ",
            ""
          ]
        },
        eras: [{ name: "לספירה", start: null, offset: 0 }],
        patterns: {
          d: "dd/MM/yyyy",
          D: "dddd dd MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dddd dd MMMM yyyy HH:mm",
          F: "dddd dd MMMM yyyy HH:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      },
      Hebrew: {
        name: "Hebrew",
        "/": " ",
        days: {
          names: [
            "יום ראשון",
            "יום שני",
            "יום שלישי",
            "יום רביעי",
            "יום חמישי",
            "יום שישי",
            "שבת"
          ],
          namesAbbr: ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
          namesShort: ["א", "ב", "ג", "ד", "ה", "ו", "ש"]
        },
        months: {
          names: [
            "תשרי",
            "חשון",
            "כסלו",
            "טבת",
            "שבט",
            "אדר",
            "אדר ב",
            "ניסן",
            "אייר",
            "סיון",
            "תמוז",
            "אב",
            "אלול"
          ],
          namesAbbr: [
            "תשרי",
            "חשון",
            "כסלו",
            "טבת",
            "שבט",
            "אדר",
            "אדר ב",
            "ניסן",
            "אייר",
            "סיון",
            "תמוז",
            "אב",
            "אלול"
          ]
        },
        eras: [{ name: "C.E.", start: null, offset: 0 }],
        twoDigitYearMax: 5790,
        patterns: {
          d: "dd MMMM yyyy",
          D: "dddd dd MMMM yyyy",
          t: "HH:mm",
          T: "HH:mm:ss",
          f: "dddd dd MMMM yyyy HH:mm",
          F: "dddd dd MMMM yyyy HH:mm:ss",
          M: "dd MMMM",
          Y: "MMMM yyyy"
        }
      }
    },
    messages: {
      AdditionalHelp: "עזרה נוספת",
      AddNewTab: "הוסף כרטיסייה חדשה",
      Alerts: "התראות",
      ApplyFilter: "החל מסנן",
      Approve: "אישור",
      Attachments: "קבצים מצורפים",
      Back: "הקודם",
      Basic: "בסיסי",
      Between: "בין",
      Book: "ספר",
      Cancel: "ביטול",
      Checked: "מסומן",
      ClearFilter: "נקה מסנן",
      Close: "סגור",
      CloseCancelChanges: "סגור ובטל שינויים",
      CloseSaveChanges: "סגור ושמור שינויים",
      CloseTab: "סגור כרטיסייה",
      ColumnPersonalization: "התאמה אישית של עמודה",
      Comments: "הערות",
      Confirmation: "אישור",
      Contains: "מכיל",
      CreateTab: "צור כרטיסייה חדשה",
      Cut: "גזור",
      Delete: "מחק",
      DiscardUndo: "בטל",
      DisplayDropDownList: "הצג רשימה נפתחת",
      Displaying: "מציג: ",
      DocWord: "מסמך",
      DoesNotContain: "אינו מכיל",
      DoesNotEndWith: "אינו מסתיים ב-",
      DoesNotEqual: "אינו שווה ל-",
      DoesNotStartWith: "אינו מתחיל ב-",
      Download: "הורד",
      Duplicate: "שכפל",
      Edit: "ערוך",
      EitherSelectedorNotSelected: "נבחר או לא נבחר",
      Email: "דואר אלקטרוני",
      EndsWith: "מסתיים ב-",
      EqualsStr: "שווה ל-",
      ExpandCollapse: "הרחב/כווץ",
      ExportFailed: "היצוא נכשל",
      ExportToExcel: "יצוא ל-Excel",
      FileInUse: "הקובץ שצוין נמצא בשימוש",
      FileInUseDetail:
        "סגור את הקובץ ביישום שבו הוא נמצא בשימוש או ציין שם קובץ אחר.",
      Filter: "מסנן",
      FilterMenu: "תפריט מסנן",
      FilterOptions: "אפשרויות מסנן",
      FilterWithinResults: "סינון בתוך התוצאות",
      First: "ראשון",
      FirstView: "הצג ראשון",
      Folder: "תיקייה",
      ForgotPassword: "שכחת את הסיסמה?",
      Forward: "קדימה",
      GetMoreRows: "קבל שורות נוספות",
      GreaterThan: "גדול מ-",
      GreaterThanOrEquals: "גדול או שווה ל-",
      GridSettings: "הגדרות רשת",
      GroupSelection: "בחירת קבוצה",
      Help: "עזרה",
      HideColumn: "הסתר עמודה",
      IsEmpty: "ריק",
      IsNotEmpty: "אינו ריק",
      Last: "אחרון",
      LastView: "הצג אחרון",
      LaunchActivate: "הפעל",
      LessThan: "קטן מ-",
      LessThanOrEquals: "קטן או שווה ל-",
      Links: "קישורים",
      ListTabs: "פרט את כל הכרטיסיות",
      LoadingItem: "טוען פריט ",
      Maintenance: "תחזוקה",
      Menu: "תפריט",
      New: "חדש",
      Next: "הבא",
      NextView: "הצג את הבא",
      No: "לא",
      NotChecked: "לא מסומן",
      Notes: "הערות",
      NotSelected: "לא נבחר",
      Of: " מתוך ",
      Ok: "אישור",
      Open: "פתח",
      Password: "סיסמה",
      Paste: "הדבק",
      Phone: "טלפון",
      PleaseWait: "אנא המתן",
      Previous: "הקודם",
      PreviousView: "הצג את הקודם",
      Print: "הדפס",
      Queries: "שאילתות",
      Redo: "בצע שוב",
      Refresh: "רענן",
      Reject: "דחה",
      RememberMe: "זכור אותי במחשב זה",
      Reports: "דוחות",
      Reset: "איפוס",
      Review: "סקירה",
      RunFilter: "הפעל מסנן",
      RunJob: "הפעל משימה",
      Save: "שמור",
      SaveBeforeClosing: "שמור לפני סגירה",
      SavedFilters: "מסננים שנשמרו",
      SaveSubmit: "שמור/שלח",
      ScreenDesign: "עיצוב מסך",
      Search: "חיפוש",
      SelectContents: "בחר תוכן",
      SelectDate: "בחר תאריך",
      SelectDeselect: "בחר הכול / בטל בחירת הכול",
      Selected: "נבחר: ",
      ServerName: "שם שרת",
      Settings: "הגדרות",
      ShowFilterRow: "הצג שורת מסנן",
      SignIn: "כניסה",
      SortAscending: "מיין בסדר עולה",
      SortDescending: "מיין בסדר יורד",
      Spreadsheet: "גיליון אלקטרוני",
      StartsWith: "מתחיל ב-",
      StatusIndicator: "מחוון מצב",
      Tasks: "משימות",
      Today: "היום",
      Translate: "תרגם",
      UserID: "מזהה משתמש",
      Utilities: "תוכניות שירות",
      Yes: "כן",
      Page: "דף",
      Rows: "שורות",
      ShowingAll: "מציג את הכול",
      SessionNavigation: "ניווט בהפעלה",
      ListAllMenuItems: "פרט את כל פריטי התפריט",
      NoRecordsFound: "לא נמצאו רשומות",
      SearchTree: "חיפוש בעץ",
      Clear: "נקה",
      DrillDown: "הסתעפות",
      Required: "שדה זה נדרש",
      Available: "זמין:",
      Add: "הוסף",
      MoveDown: "הזז למטה",
      MoveUp: "הזז למעלה",
      Remove: "הסר",
      LastYear: "השנה שעברה",
      NextMonth: "החודש הבא",
      NextWeek: "השבוע הבא",
      NextYear: "השנה הבאה",
      OneMonthAgo: "לפני חודש",
      OneWeekAgo: "לפני שבוע",
      SixMonthsAgo: "לפני שישה חודשים",
      Time: "שעה",
      CannotBeSelected: "לא ניתן לבחור שורה זו.",
      ResetToDefault: "איפוס לפריסת ברירת המחדל",
      CloseOtherTabs: "סגור כרטיסיות אחרות",
      EmailValidation: "הזן כתובת דואר אלקטרוני חוקית",
      UrlValidation: "הזן כתובת URL חוקית",
      EndofResults: "סוף התוצאות",
      More: "עוד...",
      RecordsPerPage: "רשומות בדף",
      Maximize: "להגדיל",
      Minimize: "לצמצם"
    }
  });
})(this);
